import {
  AddLocationToStack,
  Logout,
  SetAnimalSizes,
  SetCurrency,
  SetGifToShow,
  SetInitialState,
  SetLoading,
  SetPetCharacteristics,
  SetPetTypes,
  SetToken,
  SetUserHasAdotionCenter,
  UpdateUser,
} from './animalHeaven.actions.types';
import * as animalHeavenTypes from './animalHeaven.actions.types';
import {
  AnimalSize,
  PetType,
  PetCharacteristic,
  SupportedLanguage,
  Currency,
} from './animalHeaven.types';

export const setToken = (token: string): SetToken => {
  return {
    type: animalHeavenTypes.SET_TOKEN,
    payload: { token },
  };
};

export const logout = (): Logout => {
  return {
    type: animalHeavenTypes.LOGOUT,
    payload: {},
  };
};

export const setInitialState = ({
  email,
  firstName,
  id,
  isAdmin,
  language,
  lastName,
  phone,
  phoneCode,
  hasAdoptionCenter,
}: {
  email: string;
  firstName: string;
  id: string;
  isAdmin: boolean;
  language: SupportedLanguage;
  lastName: string;
  phone: string;
  phoneCode: string;
  hasAdoptionCenter: boolean;
}): SetInitialState => {
  return {
    type: animalHeavenTypes.SET_INITIAL_STATE,
    payload: {
      email,
      firstName,
      id,
      isAdmin,
      language,
      lastName,
      phone,
      phoneCode,
      hasAdoptionCenter,
    },
  };
};

export const setUserHasAdoptionCenter = (hasAdoptionCenter: boolean): SetUserHasAdotionCenter => {
  return {
    type: animalHeavenTypes.SET_USER_HAS_ADOPTION_CENTER,
    payload: { hasAdoptionCenter },
  };
};

export const updateUser = ({
  firstName,
  language,
  lastName,
  phone,
  phoneCode,
}: {
  firstName: string;
  language: SupportedLanguage;
  lastName: string;
  phone: string;
  phoneCode: string;
}): UpdateUser => {
  return {
    type: animalHeavenTypes.UPDATE_USER,
    payload: { firstName, language, lastName, phone, phoneCode },
  };
};

export const setPetTypes = (petTypes: PetType[]): SetPetTypes => {
  return {
    type: animalHeavenTypes.SET_PET_TYPES,
    payload: { petTypes },
  };
};

export const setLoading = ({
  key,
  value,
}: {
  key: 'animalSizes' | 'petTypes' | 'petCharacteristics';
  value: boolean;
}): SetLoading => {
  return {
    type: animalHeavenTypes.SET_LOADING,
    payload: { key, value },
  };
};

export const setGifToShow = ({ gifName }: { gifName: string }): SetGifToShow => ({
  type: animalHeavenTypes.SET_GIF_TO_SHOW,
  payload: { gifName },
});

export const setAnimalSizes = (animalSizes: AnimalSize[]): SetAnimalSizes => {
  return {
    type: animalHeavenTypes.SET_ANIMAL_SIZES,
    payload: { animalSizes },
  };
};

export const addLocationToStack = (location: string): AddLocationToStack => {
  return {
    type: animalHeavenTypes.ADD_LOCATION_TO_STACK,
    payload: { location },
  };
};

export const setPetCharacteristics = (
  petCharacteristics: PetCharacteristic[]
): SetPetCharacteristics => {
  return {
    type: animalHeavenTypes.SET_PET_CHARACTERISTIC,
    payload: { petCharacteristics },
  };
};

export const setCurrency = (currency: Currency): SetCurrency => {
  return {
    type: animalHeavenTypes.SET_CURRENCY,
    payload: { currency },
  };
};
